import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { createTuinaReservation } from '@/service/tuina'
import ReservationCreateForm from './ReservationCreateForm'

const fromValue = (fields) => ({
  memberId: fields.memberId,
  projectId: fields.projectId,
  therapistId: fields.therapistId,
  appointmentDate: fields.appointmentDate,
  startTime: fields.startTime,
  remark: Array.isArray(fields.remark) ? fields.remark.join(',') : (fields.remark == null ? '' : fields.remark)
})

class ReservationCreateModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSuccess: PropTypes.func
  }

  handleOk = async (form) => {
    const { onSuccess } = this.props
    const fields = await form.current.validateFields()
    await createTuinaReservation(fromValue(fields))
    message.success('已新建')
    if (typeof onSuccess === 'function') onSuccess()
  }

  render () {
    const { children, storeId, date } = this.props
    return (
      <WrappedModal
        children={children}
        title="新建订单"
        okText="提交"
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={560}
        baseComponent={<ReservationCreateForm />}
        baseProps={{ storeId, date }}
        onOk={this.handleOk}
      />
    )
  }
}

export default ReservationCreateModal
